exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".benefits-container[data-v-1d4584c8]{display:flex;align-items:center}@media (max-width:369px){.benefits-container[data-v-1d4584c8]{justify-content:flex-end}}", ""]);

